export interface Story {
  id: string;
  name: string;
  age: number;
  journey: string;
  result: string;
  shortQuote: string;
  teaser: string;
  highlight: string;
}

export const stories: Story[] = [
  {
    id: "marcus",
    name: "Marcus Chen",
    age: 52,
    journey: "Complicated Diets, Constant Tracking",
    result: "Simple eating, no tracking",
    shortQuote: "I spent years counting every calorie. Now I just eat meat and live my life.",
    highlight: "Found Simplicity",
    teaser: "Marcus tried every diet app, every tracking method, every meal plan. Nothing stuck longer than a few weeks. Then his daughter introduced him to carnivore—and everything changed."
  },
  {
    id: "elena",
    name: "Elena Rodriguez",
    age: 38,
    journey: "Diet Exhaustion, Constant Decision Fatigue",
    result: "Mental clarity, simplified routine",
    shortQuote: "I used to spend hours planning meals. Now I know exactly what I'm eating. The mental freedom is incredible.",
    highlight: "Escaped Diet Culture",
    teaser: "Elena was exhausted from the mental load of dieting—tracking macros, planning meals, reading labels. She wanted something she could actually sustain. She found it."
  },
  {
    id: "derek",
    name: "Derek Washington",
    age: 44,
    journey: "Former Athlete, Lost His Way",
    result: "Active lifestyle, training again",
    shortQuote: "I stopped feeling like a former athlete. I started feeling like an athlete again.",
    highlight: "Back to Training",
    teaser: "Derek missed the active person he used to be. Years of complicated diets and yo-yo results left him frustrated. Carnivore's simplicity helped him find his way back."
  },
  {
    id: "vanessa",
    name: "Vanessa Morrison",
    age: 35,
    journey: "Constant Hunger, Diet Burnout",
    result: "Satisfied eating, sustainable routine",
    shortQuote: "For the first time, I eat until I'm satisfied and don't think about food until my next meal.",
    highlight: "Freedom from Food Obsession",
    teaser: "Vanessa was always hungry. Every diet left her counting down to the next meal. She discovered what happens when you stop fighting your appetite and start working with it."
  },
  {
    id: "raymond",
    name: "Raymond Jackson",
    age: 61,
    journey: "Skeptic, Traditional Eating Habits",
    result: "Converted believer, newfound energy",
    shortQuote: "I'm not a doctor. I'm just someone who was skeptical until I tried it myself.",
    highlight: "From Skeptic to Advocate",
    teaser: "Raymond thought eating only meat was crazy. His granddaughter challenged him to try it for 30 days. Six months later, he's still going—and telling everyone who'll listen."
  },
  {
    id: "jasmine",
    name: "Jasmine Wheeler",
    age: 47,
    journey: "Busy Professional, No Time to Cook",
    result: "Simplified meal prep, more time",
    shortQuote: "My colleagues ask how I have energy at 4pm when they're reaching for coffee. Simple: I stopped fighting my biology.",
    highlight: "Simplified Her Life",
    teaser: "Professor Jasmine thought healthy eating required elaborate meal prep. She didn't have time. Then she discovered the most nutrient-dense foods are also the simplest to prepare."
  },
  {
    id: "carlos",
    name: "Carlos Mendez",
    age: 39,
    journey: "Active Job, Needed Sustainable Fuel",
    result: "Consistent energy, no afternoon crashes",
    shortQuote: "My wife said I got my spark back. The man who used to come home exhausted is gone.",
    highlight: "Consistent Energy All Day",
    teaser: "Carlos works construction and needed something that would keep him going. Complicated diets didn't fit his life. He found what did."
  },
  {
    id: "tiffany",
    name: "Tiffany Chen",
    age: 31,
    journey: "Entrepreneur, Needed Mental Clarity",
    result: "Sharp focus, simplified routine",
    shortQuote: "The million-dollar business was exhausting. The better business came when I simplified everything—including how I eat.",
    highlight: "Sharper Focus",
    teaser: "Tiffany built a successful business while constantly distracted by food decisions. She wanted mental clarity. She found it by eliminating the complexity."
  },
  {
    id: "william",
    name: "William Foster",
    age: 68,
    journey: "Retirement, Wanted to Stay Sharp",
    result: "Active mind, new hobbies",
    shortQuote: "The second act is not about slowing down. It's about simplifying what doesn't matter.",
    highlight: "Still Sharp at 68",
    teaser: "William wanted to stay active and engaged in retirement. He found that simplifying his eating gave him more energy for the things that matter—like beating his grandson at chess."
  },
  {
    id: "keisha",
    name: "Keisha Brown",
    age: 42,
    journey: "Emotional Relationship with Food",
    result: "Peace with food, no more stress eating",
    shortQuote: "I finally stopped thinking about food all the time. I just eat and move on.",
    highlight: "Peace with Food",
    teaser: "Keisha had a complicated relationship with food. Every diet made it worse. She found that simplifying to the basics changed everything about how she thinks about eating."
  },
  {
    id: "damon",
    name: "Damon Price",
    age: 28,
    journey: "Young Professional, Scattered Focus",
    result: "Improved concentration, steady energy",
    shortQuote: "For the first time, I can focus on work without thinking about what I'm eating next.",
    highlight: "Found His Focus",
    teaser: "Damon's mind was always racing—about work, about food, about everything. Simplifying his diet helped simplify his thinking. Fewer decisions, clearer focus."
  },
  {
    id: "donna",
    name: "Donna Mitchell",
    age: 55,
    journey: "Empty Nester, New Chapter",
    result: "Active lifestyle, running with family",
    shortQuote: "I'm 55 years old. And I'm just getting started.",
    highlight: "Running With Her Grandkids",
    teaser: "Donna's kids had left home and she wanted to start her next chapter strong. She found that carnivore gave her the energy to do things she hadn't done in years—like running with her grandchildren."
  }
];

export const getStoryById = (id: string): Story | undefined => {
  return stories.find(story => story.id === id);
};

export const getFeaturedStories = (): Story[] => {
  return stories.slice(0, 4);
};
